module.exports = __webpack_public_path__ + "static/media/affiliate-tutorial-step-2.182ad376.webp";